import axios from "axios"

const ChaiseService = {}

ChaiseService.ajouter =(formData,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/chaise/ajouter`, formData ,{
    headers:{
    'Authorization': `Bearer ${authorization}` 
    }
})

}
export default ChaiseService ;